module.exports = __webpack_public_path__ + "media/images/plans/e-photo_location/pickup-3-3e4c5de7747250def4e2ee28d3a95359.png";